import { FC, useEffect } from "react"
import { MenuComponent } from "../../../../../../../../_metronic/assets/ts/components"
import { KTSVG } from "../../../../../../../../_metronic/helpers"
import { Note } from "../../../../../applications"
import { orderBy } from "lodash"
import { NoteCard } from "../../../../../../../components/widgets"

type Props = {
  notes: Array<Note>
  terminationNotes?: Array<Note>
}

const DLMSiteApplicationsNotesCell: FC<Props> = ({notes, terminationNotes}) => {    
  useEffect(() => {
    if ((notes && notes.length > 0) || (terminationNotes && terminationNotes.length > 0)) {
      MenuComponent.reinitialization();
    }
  }, [notes, terminationNotes])

  if (! ((notes && notes.length > 0) || (terminationNotes && terminationNotes.length > 0))) {
    return null;
  }

  return (
    <div className="align-top">
    <button
        className='btn btn-light btn-active-light-primary btn-sm px-2 ms-n4'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-start'
        title="Notes"
    >
        <KTSVG path='/media/icons/duotune/communication/com007.svg' className='svg-icon-2 m-0' />
    </button>
      
    <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 p-4 mw-500px'
        data-kt-menu='true'
    >       
    { (terminationNotes && terminationNotes.length > 0) &&
      <>
      {
      orderBy(terminationNotes, ['dteCr'], ['desc']).map( (note, idx) => {
          return (
              <NoteCard key={`termNote${idx}`} note={note} />                            
          )
      })
      }
      <div className='separator border-gray-200 mt-2 mb-3'></div>
      </>
    }                   
    { (notes && notes.length > 0) ? (
        orderBy(notes, ['dteCr'], ['desc']).map( (note, idx) => {
            return (
                <NoteCard key={`note${idx}`} note={note} />                            
            )
        })
    ) : (
        <div className="text-muted fs-7">none</div>
    )       
    }                         
    </div>    
    </div>
  )
}

export {DLMSiteApplicationsNotesCell}
